import { app } from '../../../bootstrap/core';
import { cardContainerComponent } from './cardContainer.component';
import contractringPartnersTemplate from './partials/contracting-partners.tpl.html';

app.component('cardContainer', cardContainerComponent);
app.value('contractringPartnersTemplate', contractringPartnersTemplate);
